import { RootState } from "../../../../store";
import { taskManagementTaskIdSelector } from "../properties/taskManagementTaskIdSelector";

export const isTaskManagementDrawerEditModeSelector = (state: RootState) => {
  const id = taskManagementTaskIdSelector(state);

  return !!id;
};
